import React, { useState } from "react";
import { Formik } from "formik";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import * as api from "../../api";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { FormikDisabler } from "@poseidon/ui/components/FormikDisabler";
import { usePermissions } from "@poseidon/ui/components";
import { isApplicationEditable } from "../../isApplicationEditable";

export default function EditApplicationFormWrapper({
  initialValues,
  application,
  children,
}) {
  const { canWrite } = usePermissions();
  const { setToast } = useToastMessage();
  const { setError } = useErrorMessage();
  const [saving, setSaving] = useState(false);
  const applicationId = initialValues.id || application.id;
  const readonly = !isApplicationEditable({
    ...(application ?? {}),
    ...initialValues,
  });
  const childrenIsFunc = typeof children === "function";
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={async (values) => {
        try {
          setSaving(true);
          await api.updateApplication(applicationId, values);
          setToast("Successfully updated Application");
        } catch (error) {
          console.error(error);
          setError(error.message);
        }
        setSaving(false);
      }}
    >
      {childrenIsFunc ? (
        (context) => (
          <Form>
            <FormikDisabler disabled={readonly || saving || !canWrite} />
            {children(context)}
          </Form>
        )
      ) : (
        <Form>
          <FormikDisabler disabled={readonly || saving || !canWrite} />
          {children}
        </Form>
      )}
    </Formik>
  );
}
